<section class="main-next" id="main-next">
    <div class="container-fluid title-container sticky">
        <h1 class="outlined-title">Ya nos conoces</h1>
        <h1 class="filled-title">¿Cuál es el siguiente paso?</h1>
    </div>
</section>


